"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sofaSubTypes = exports.seatAndBackSubTypes = exports.getSofaTypes = exports.getSeatAndBackTypes = exports.combineArraysRec = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// *** Version: 12 ***

var seatAndBackSubTypes = exports.seatAndBackSubTypes = [{
  name: 'Types',
  slug: 'types',
  items: [{
    name: 'Coussin plat',
    slug: 'SIMPLE'
  }, {
    name: 'Structuré',
    slug: 'COMPLEX'
  }]
}, {
  name: 'Tailles',
  slug: 'sizes',
  items: [{
    name: '< 75cm',
    slug: 'SMALL'
  }, {
    name: '> 75cm',
    slug: 'BIG'
  }]
}, {
  name: 'Formes',
  slug: 'shapes',
  items: [{
    name: 'Rectangle',
    slug: 'RECTANGLE'
  }, {
    name: 'Ajusté aux accoudoirs',
    slug: 'ADJUSTED'
  }]
}, {
  name: 'Fermetures',
  slug: 'closings',
  items: [{
    name: 'Zip fourni',
    slug: 'ZIPPROVIDED'
  }, {
    name: 'Zip invisible fourni',
    slug: 'INVISIBLEZIPPROVIDED'
  }, {
    name: 'Zip non fourni',
    slug: 'ZIP'
  }, {
    name: 'Zip invisible non fourni',
    slug: 'INVISIBLEZIP'
  }]
}];
var CUTOUT_PRICE = 1;
var NUMBER_OF_CUTOUTS = {
  SIMPLE_RECTANGLE: 2,
  SIMPLE_ADJUSTED: 2,
  COMPLEX_RECTANGLE: 5,
  COMPLEX_ADJUSTED: 6
};
var OVERCASTING_PRICES = {
  SMALL: 3,
  BIG: 4
};
var NUMBER_OF_OVERCASTINGS = 1;
var SIDE_TO_ASSEMBLE_PRICES = {
  SMALL: 2.5,
  BIG: 3
};
var NUMBER_OF_SIDES_TO_ASSEMBLE = {
  SIMPLE_RECTANGLE: 0,
  SIMPLE_ADJUSTED: 0,
  COMPLEX_RECTANGLE: 8,
  COMPLEX_ADJUSTED: 10
};
var SMALL_SEAM_PRICE = 1;
var NUMBER_OF_SMALL_SEAMS = {
  SIMPLE_RECTANGLE: 0,
  SIMPLE_ADJUSTED: 0,
  COMPLEX_RECTANGLE: 4,
  COMPLEX_ADJUSTED: 5
};
var SIDE_SEAM_PRICES = {
  SMALL: 3,
  BIG: 4
};
var NUMBER_OF_SIDE_SEAMS = {
  SIMPLE_RECTANGLE: 4,
  SIMPLE_ADJUSTED: 5,
  COMPLEX_RECTANGLE: 0,
  COMPLEX_ADJUSTED: 0
};
var ZIP_PRICES = {
  ZIPPROVIDED: 12,
  INVISIBLEZIPPROVIDED: 19,
  ZIP: 15,
  INVISIBLEZIP: 22
};
var formSeatAndBackType = function formSeatAndBackType(item1, item2) {
  var updatedType = {
    name: "".concat(item1.name, " - ").concat(item2.name),
    type: item1.type || '',
    shape: item1.shape || '',
    size: item1.size || '',
    closing: item1.closing || ''
  };
  if (item1.subCategoryType === 'types') updatedType.type = item1.slug;
  if (item2.subCategoryType === 'sizes') updatedType.size = item2.slug;
  if (item2.subCategoryType === 'shapes') updatedType.shape = item2.slug;
  if (item2.subCategoryType === 'closings') updatedType.closing = item2.slug;
  return updatedType;
};
var formSofaType = function formSofaType(item1, item2) {
  var updatedType = {
    name: "".concat(item1.name, " - ").concat(item2.name),
    length: item1.length || '',
    width: item1.width || ''
  };
  if (item1.subCategoryType === 'length') updatedType.length = item1.slug;
  if (item2.subCategoryType === 'width') updatedType.width = item2.slug;
  return updatedType;
};
var _combineArraysRec = exports.combineArraysRec = function combineArraysRec(formType, arrayOfArrays) {
  var currentCombinations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  if (arrayOfArrays.length === 0) return currentCombinations;
  var currentArray = arrayOfArrays.shift();
  var newCombinations = currentCombinations.length > 0 ? currentCombinations.reduce(function (acc, it) {
    currentArray.forEach(function (item) {
      return acc.push(formType(it, item));
    });
    return acc;
  }, []) : currentArray;
  return _combineArraysRec(formType, arrayOfArrays, newCombinations);
};
var getSeatAndBackTypes = exports.getSeatAndBackTypes = function getSeatAndBackTypes() {
  var isSeat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var arraysOfItems = seatAndBackSubTypes.map(function (_ref) {
    var slug = _ref.slug,
      items = _ref.items;
    return items.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        subCategoryType: slug
      });
    });
  });
  var types = _combineArraysRec(formSeatAndBackType, arraysOfItems.slice());
  return types.map(function (_ref2, index) {
    var name = _ref2.name,
      type = _ref2.type,
      size = _ref2.size,
      shape = _ref2.shape,
      closing = _ref2.closing;
    return {
      id: "12.crea_".concat(isSeat ? 'assi' : 'doss', "-type-").concat(index),
      slug: "".concat(type, "_").concat(size, "_").concat(shape, "_").concat(closing),
      name: name,
      price: Math.round(NUMBER_OF_CUTOUTS["".concat(type, "_").concat(shape)] * CUTOUT_PRICE + NUMBER_OF_OVERCASTINGS * OVERCASTING_PRICES[size] + NUMBER_OF_SIDES_TO_ASSEMBLE["".concat(type, "_").concat(shape)] * SIDE_TO_ASSEMBLE_PRICES[size] + NUMBER_OF_SMALL_SEAMS["".concat(type, "_").concat(shape)] * SMALL_SEAM_PRICE + NUMBER_OF_SIDE_SEAMS["".concat(type, "_").concat(shape)] * SIDE_SEAM_PRICES[size] + ZIP_PRICES[closing])
    };
  });
};
var sofaSubTypes = exports.sofaSubTypes = [{
  name: 'Longueur',
  slug: 'length',
  items: [{
    name: 'Fauteuil',
    slug: 'SEAT1'
  }, {
    name: '2 places (< 165cm)',
    slug: 'SEAT2'
  }, {
    name: '3 places (< 245cm)',
    slug: 'SEAT3'
  }, {
    name: '4 places (< 325cm)',
    slug: 'SEAT4'
  }, {
    name: '5 places et + (> 325cm)',
    slug: 'SEAT5'
  }]
}, {
  name: 'Largeur',
  slug: 'width',
  items: [{
    name: '< 81cm',
    slug: 'SMALL'
  }, {
    name: '> ou = 81cm',
    slug: 'BIG'
  }]
}];
var COMPLEX_SEAM_PRICES = {
  SMALL: 22,
  BIG: 25
};
var NUMBER_OF_COMPLEX_SEAMS = {
  SEAT1: 1,
  SEAT2: 2,
  SEAT3: 3,
  SEAT4: 3.5,
  SEAT5: 4
};
var HEM_PRICES = {
  SEAT1: 30,
  SEAT2: 40,
  SEAT3: 40,
  SEAT4: 50,
  SEAT5: 50
};
var getSofaTypes = exports.getSofaTypes = function getSofaTypes() {
  var arraysOfItems = sofaSubTypes.map(function (_ref3) {
    var slug = _ref3.slug,
      items = _ref3.items;
    return items.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        subCategoryType: slug
      });
    });
  });
  var types = _combineArraysRec(formSofaType, arraysOfItems.slice());
  return types.map(function (_ref4, index) {
    var name = _ref4.name,
      length = _ref4.length,
      width = _ref4.width;
    return {
      id: "12.crea_cana-type-".concat(index),
      slug: "".concat(length, "_").concat(width),
      name: name,
      price: Math.round(NUMBER_OF_COMPLEX_SEAMS[length] * COMPLEX_SEAM_PRICES[width] + HEM_PRICES[length])
    };
  });
};